/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {ClaimsComponent} from './claims/claims.component';
import {ESSService} from './employee-self.service';
import {ESSComponent} from './ess.component';
import {LeaveRequestComponent} from './leave-request/leave-request.component';
import {MyDocumentsComponent} from './my-documents/my-documents.component';
import {PayslipsComponent} from './payslips/payslips.component';
import {PersonalInfoComponent} from './personal-info/personal-info.component';

import {MomentModule} from 'ngx-moment';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {TimeModule} from '../+payrolls/prepare/time/time.module';
import {ReportsModule} from '../+reports/reports.module';
import {RouteGuard} from '../shared/authentication/roles/route-guard';
import {ClaimsFormModule} from '../shared/claim-form/claim-form.module';
import {ContractDataModule} from '../shared/contract-data/contract-data.module';
import {ContractEmployeeMenuModule} from '../shared/contract-employee-menu/contract-employee-menu.module';
import {DocumentsModule} from '../shared/documents/documents.module';
import {EmployeesSharedModule} from '../shared/employees/employees-shared.module';
import {FilesModule} from '../shared/files/files.module';
import {FormGeneratorModule} from '../shared/form-generator/form-generator.module';
import {ModalModule} from '../shared/modal/modal.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {TeamsSharedModule} from '../shared/teams/teams-shared.module';
import {UiModule} from '../shared/ui/ui.module';
import {UserModule} from '../shared/user/user.module';

const routes: Routes = [
  {
    path: '',
    component: ESSComponent,
    children: [
      {
        path: 'leave-request',
        component: LeaveRequestComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'payslips',
        component: PayslipsComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'claims',
        component: ClaimsComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'documents',
        component: MyDocumentsComponent,
        canActivate: [RouteGuard]
      }
    ]
  },
  {
    path: 'personal-info',
    component: PersonalInfoComponent,
    canActivate: [RouteGuard]
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    ModalModule,
    UiModule,
    TooltipModule.forRoot(),
    PipesModule,
    FilesModule,
    UserModule,
    FormGeneratorModule,
    TranslateModule,
    TabsModule.forRoot(),
    EmployeesSharedModule,
    TeamsSharedModule,
    TimeModule.forRoot(),
    RouterModule.forChild(routes),
    PdfViewerModule,
    ReportsModule,
    ContractEmployeeMenuModule,
    ContractDataModule,
    ClaimsFormModule,
    DocumentsModule
  ],
  declarations: [
    ESSComponent,
    PersonalInfoComponent,
    LeaveRequestComponent,
    PayslipsComponent,
    ClaimsComponent,
    MyDocumentsComponent
  ],
  exports: [
    RouterModule
  ]
})

export class ESSModule {
  public static forRoot(): ModuleWithProviders<UserModule> {
    return {
      ngModule: UserModule,
      providers: [
        ESSService
      ]
    };
  }
}
